module.exports = __webpack_public_path__ + "img/logo.9fa8eb95.svg";